module.exports = __webpack_public_path__ + "img/kick-scooter.904bd634.svg";